<template>
    <Carrito 
        button_color="white" 
        :carritoItems="carritoItems" 
        :secondsLeft="carrito?.seconds_left"
        @eliminarProducto="eliminarProducto"
        @irADetalleCarrito="irADetalleCarrito" 
    />
</template>

<script>
    import Carrito from '../../common/carrito/Carrito.vue';

    export default {
        props: {
            button_color: String,
        },
        methods: {
            getCarritoActivo() {
                const params = {
                    filters : {}
                }

                this.$store.dispatch(this.config.getVuexAlias('taquilla.carrito.activo'), params);
            },
            eliminarProducto(item_id) {
                const params = {
                    filters: {},
                    cart_id: this.carrito?.id,
                    item_id: item_id
                };

                this.$store.dispatch(this.config.getVuexAlias('taquilla.carrito.delete-items'), params).then(res => {
                    this.$toast.success('Entrada borrada correctamente');
                    this.$store.dispatch('TAQUILLA_CARRITO_ITEMS', { cart_id: this.carrito.id, filters: {}})
                        .then(() => {
                            if (this.carritoItems.length === 0) {
                                this.$store.dispatch('TAQUILLA_CARRITO_ELIMINAR', { cart_id: this.carrito.id, filters: { }});
                            }
                        });
                }).catch(err => {
                    console.error('Error actualizando carrito online:', err);
                });
            },
            irADetalleCarrito() {
                this.$router.push({ name: 'back.carrito' });
            }
        },
        watch: {
            'carrito.seconds_left': function(newVal) {
                if (newVal === 0) {
                    this.$modal.show('carrito-terminado');
                    this.$router.push({ path: '/admin/eventos' });
                }
            }
        },
        computed: {
            carrito() {
                return this.$store.getters.getCarritoActivo;
            },
            carritoItems() {
                return this.$store.getters.getCarritoItems;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
        created() {
            this.getCarritoActivo();
        },
        components: { Carrito },
    };
</script>
